import { StyledCard } from '@app/components/StyledCard';
import { getAlertsWhatsappGroup } from '@app/modules/admin/api';
import { CopyBtn } from '@mi-front/ui';
import { Box, Grid, Link, Button } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { FormattedMessage } from 'react-intl';
type Props = Record<string, never>;

export const ManageAlertsWaGroup = (p: Props) => {
  const [enabled, setEnabled] = useState(false);
  const query = useQuery({
    queryKey: ['alerts-wa-group'],
    queryFn: () => getAlertsWhatsappGroup(),
    enabled,
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <StyledCard
          title={
            <FormattedMessage
              id="admin.alertsScreen.waGroup.title"
              defaultMessage="Grupo de WhatsApp para alertas"
            />
          }
        >
          {!query.data && (
            <Box mt={2}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => setEnabled(true)}
                loading={query.isLoading}
              >
                <FormattedMessage
                  id="admin.dashboard.btnLink"
                  defaultMessage="Obtener enlace de invitación del grupo"
                />
              </Button>
            </Box>
          )}
          {query.data && (
            <Box>
              <Box mb={2}>
                <Link href={query.data.groupInviteLink} target="_blank">
                  {query.data.groupInviteLink}
                </Link>
              </Box>
              <CopyBtn
                size="small"
                children={
                  <FormattedMessage
                    id="admin.dashboard.copyLink"
                    defaultMessage="Copiar URL del enlace"
                  />
                }
                copyValue={query.data.groupInviteLink}
              />
            </Box>
          )}
        </StyledCard>
      </Grid>
    </Grid>
  );
};
